<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        elevationLevel?: 'canvas' | 'stacked' | 'above' | 'sticky';
        inverted?: boolean;
        size?: '100' | '50';
        backgroundColor?: string;
        /*                                                                                        */
        disableOverlayEffect?: boolean;
        /*                                                                                          */
        element?: HTMLElement | null;
        /*                                                                                               */
        primaryAction?: Snippet;
        /*                                        */
        children?: Snippet;
        /*                                                                                                 */
        [key: `data-${string}`]: string | undefined;
        /**
 *
 *
 */
        fullHeight?: boolean;
    }

    let {
        elevationLevel = 'canvas',
        inverted = false,
        size = '100',
        backgroundColor,
        disableOverlayEffect = false,
        element = $bindable(null),
        primaryAction,
        children,
        fullHeight = false,
        ...rest
    }: Props = $props();

    const hasPrimaryAction = $derived(!!primaryAction);
</script>

<div
    {...rest}
    class="reptile-card"
    class:reptile-card--size-50={size === '50'}
    class:reptile-card--inverted={inverted}
    class:reptile-card--full-height={fullHeight}
    data-elevation-level={elevationLevel}
    style:--reptile-card-background-color={backgroundColor}
    bind:this={element}
>
    <div
        class="reptile-card__surface"
        class:reptile-card__surface--no-overlay={disableOverlayEffect}
        class:reptile-card__surface--has-primary-action={hasPrimaryAction}
    >
        {@render primaryAction?.()}
        {@render children?.()}
    </div>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-card {
        position: relative;
        container-type: inline-size;
        display: block;

        /*                                                                                                    */
        border-radius: var(--reptile-tile-radius, #{tokens.$oc-semantic-border-radius-200});

        &--size-50 {
            border-radius: var(--reptile-tile-radius, #{tokens.$oc-semantic-border-radius-100});
        }

        /*                                                                                              */
        &[data-elevation-level='canvas'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-background-canvas});
            filter: tokens.$oc-semantic-shadow-canvas;
        }

        &[data-elevation-level='stacked'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-stacked-background});
            filter: tokens.$oc-semantic-shadow-stacked;
        }

        &[data-elevation-level='above'] {
            transform: translateZ(0); /*                                                     */
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-above-background});
            filter: tokens.$oc-semantic-shadow-above;
        }

        &[data-elevation-level='sticky'] {
            transform: translateZ(0); /*                                                     */
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-sticky-background});
            filter: tokens.$oc-semantic-shadow-sticky;
        }

        /*                                                                                               */
        /*                                                 */
        &--inverted {
            color: tokens.$oc-semantic-color-text-inverted;
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-background-strong-mint});
        }

        &--full-height {
            height: 100%;
        }
    }

    .reptile-card__surface {
        position: relative;

        overflow: hidden; /*                                                                          */
        display: block;

        width: 100%;
        height: 100%;
        border-radius: inherit;

        /*                                                                                 */
        /*                                                                                           */
        /*                                                                                    */
        /*                                            */
        :global(> [data-primary-action]) {
            all: unset;

            pointer-events: auto;
            cursor: pointer;

            position: absolute;
            inset: 0;

            display: block;

            box-sizing: border-box;
            width: 100%;
            height: 100%;
        }

        /*                                                                     */
        :global(> [data-primary-action] > a) {
            position: absolute;
            inset: 0;
        }

        /*                                                                                         */
        /*                                                                               */
        /*                                                                                       */
        /*                                                                                            */
        /*                                                                                   */
        /*                                                                                       */
        /*                                                                                     */
        /*                             */
        &--has-primary-action,
        &:has(:global(> [data-primary-action])) {
            pointer-events: none;

            &:not(.reptile-card__surface--no-overlay) {
                &:active::after {
                    pointer-events: none;
                    content: '';

                    position: absolute;
                    inset: 0;

                    border-radius: inherit;

                    background-color: tokens.$oc-semantic-color-overlay-active;
                }

                @media (hover: hover) and (pointer: fine) {
                    &:hover::after {
                        pointer-events: none;
                        content: '';

                        position: absolute;
                        inset: 0;

                        border-radius: inherit;

                        background-color: tokens.$oc-semantic-color-overlay-hover;
                    }
                }
            }
        }

        :global([data-secondary-action]) {
            pointer-events: auto;
            position: relative;
        }
    }
</style>
